/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Build_Manual_DescInputs */

const en_mk_build_manual_desc = /** @type {(inputs: Mk_Build_Manual_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect your computer through Desktop or CLI and work through the plan with your chosen agent. Bystep prepares the tasks, context, and checks.`)
};

const id_mk_build_manual_desc = /** @type {(inputs: Mk_Build_Manual_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hubungkan komputer melalui Desktop atau CLI, lalu kerjakan rencana dengan agent pilihanmu. Bystep menyiapkan tugas, konteks, dan pemeriksaannya.`)
};

/**
* | output |
* | --- |
* | "Connect your computer through Desktop or CLI and work through the plan with your chosen agent. Bystep prepares the tasks, context, and checks." |
*
* @param {Mk_Build_Manual_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_build_manual_desc = /** @type {((inputs?: Mk_Build_Manual_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Build_Manual_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_build_manual_desc(inputs)
	return en_mk_build_manual_desc(inputs)
});